module.exports = __webpack_public_path__ + "img/icon_charge_on.076cc639.png";